import { Component, Input, OnInit } from '@angular/core';


@Component({
  standalone: false,
  selector: 'sc-activity-item',
  templateUrl: './activity-item.component.html',
  styleUrls: ['./activity-item.component.scss']
})
export class ActivityItemComponent implements OnInit {

  @Input()
  activity : any;

  @Input()
  showProjectName = false;

  @Input()
  condensed = false;

  @Input()
  language: 'de' | 'en' = 'de';

  // where the feed is shown, e.g. 'candidate' in a candidate's own feed
  @Input()
  context: string = null;

  constructor() { }

  ngOnInit()
  {
  }
}
